<script>
import router from "../../router";
export default {
  name: "Register",
  data() {
    return {
      user: {
        email: null,
        password: null,
        business_name: null,
        business_type: "",
        country_id: "",
        ui_language: "9f9a3305-f013-425d-8478-2f5334e02188"
      },
      countries: []
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.register();
          return;
        }
      });
    },
    register() {
      this.$api
        .postAPI({
          _action: "/register",
          _body: this.user,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          this.getAccesstoken();
        })
        .catch(e => {});
    },
    getMe() {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          localStorage.setItem("user", res.user);
          localStorage.setItem("d2c_type", res.user.d2c_type);
          router.push("/settings");
        });
    },
    getAccesstoken() {
      this.$api
        .getAccesstoken({
          _action: "/oauth/token",
          _body: { email: this.user.email, password: this.user.password }
        })
        .then(res => {
          if (res){
            if (res.token){
              localStorage.setItem("access_token", res.token);
            }
          }
          this.getMe();
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    getCountryList() {
      this.$api
        .getAPI({
          _action: "/country/list"
        })
        .then(res => {
          this.countries = res.list;
        });
    }
  },
  mounted() {
    this.getCountryList();
  }
};
</script>

<template>
  <div id="main-wrapper" class="login-wrap regis-wrap">
    <div class="container h-100">
      <div class="row justify-content-md-center align-items-center h-100">
        <div class="col-lg-7">
          <div class="card w-100 rounded-10 px-4 py-3">
            <div class="card-header text-center bg-white rounded-10">
              <img src="/images/Tokoin-Logo.svg?=2" width="220" />
              <p class="font-24">{{$lang.messages.create_your_free_tokoin_account}} </p>
            </div>

            <div class="card-body">
              <form class="form-style" >
                <div class="form-group">
                  <label for="exampleInputEmail1">{{$lang.messages.email}}</label>
                  <input
                    name="email"
                    v-model="user.email"
                    v-validate="'required|email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>

                <div class="form-group">
                  <label for="exampleInputPassword1">{{$lang.messages.password}}</label>
                  <input
                    name="password"
                    v-model="user.password"
                    v-validate="'required'"
                    :class="{'form-control' : true,'input': true, 'is-danger': errors.has('password') }"
                    type="password"
                    v-bind:placeholder="$lang.messages.password"
                  />
                  <i v-show="errors.has('password')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('password')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_password}}</span>
                </div>

                <div class="form-group">
                  <label for="BusinessName">{{$lang.messages.business_name}}</label>
                  <input
                    name="BusinessName"
                    v-model="user.business_name"
                    v-validate="'required'"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                   v-bind:placeholder="$lang.messages.business_name"  
                  />
                  <i v-show="errors.has('BusinessName')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('BusinessName')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_business_name}}</span>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group mb-4">
                      <label for>{{$lang.messages.business_type}}</label>
                      <div class="custom-select-dd">
                        <select
                          v-model="user.business_type"
                          v-validate="'required'" class="form-control"
                          name="business_type"
                        >
                          <option value>{{$lang.messages.select}}</option>
                          <option value="RETAIL">{{$lang.messages.retail}}</option>
                          <option value="RESTAURANTS ">{{$lang.messages.restaurants}}</option>
                        </select>
                        <br />
                        <i v-show="errors.has('business_type')" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('business_type')"
                          class="help is-danger"
                        >{{$lang.messages.please_select_business_type}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group mb-4">
                      <label for>{{$lang.messages.country}}</label>
                      <div class="custom-select-dd">
                        <select v-model="user.country_id" v-validate="'required'" name="country_id" class="form-control">
                          <option value>{{$lang.messages.select}}</option>
                          <option
                            v-for="country in countries"
                            :key="country.id"
                            :value="country.id"
                          >{{country.name}}</option>
                        </select>
                        <br />
                        <i v-show="errors.has('country_id')" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('country_id')"
                          class="help is-danger"
                        >{{$lang.messages.please_select_country}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group form-check overflow-auto pl-0 mb-4">
                  <div class="custom-control custom-checkbox mr-sm-2 float-left">
                    <input
                      type="checkbox"
                      v-validate="'required'"
                      class="custom-control-input"
                      name="terms"
                      id="customControlAutosizing1"
                    />
                    <label
                      class="custom-control-label text-dark ml-2"
                      for="customControlAutosizing1"
                    >
                      {{$lang.messages.i_understand_and_agree_to_tokoin}}
                      <a
                        v-bind:href="BASE_URL + '/terms_and_condition/' + user.country_id" target="_blank"
                        class="text-primary"
                      >{{$lang.messages.terms_of_use}}</a>
                      {{$lang.messages.and}}
                      <a
                         v-bind:href="BASE_URL + '/privacy_policy/' + user.country_id" target="_blank"
                        class="text-primary"
                      >{{$lang.messages.privacy_policy}}</a>
                    </label>

                    <br />
                    <i v-show="errors.has('terms')" class="fa fa-warning"></i>
                    <span
                      class="help is-danger"
                      v-show="errors.has('terms')"
                    >{{$lang.messages.please_agree_to_tokoin_terms}}</span>
                  </div>
                </div>
                <button
                  type="button"
                  id="save-btn"
                  class="btn btn-primary btn-block"
                  @click="validateBeforeSubmit"
                >{{$lang.messages.register}}</button>
              </form>
            </div>
            <div class="card-footer text-center bg-white rounded-10">
              <div class="d-flex justify-content-center links">
                {{$lang.messages.already_have_an_account}}
                <a class="ml-2 text-primary">
                  <router-link to="/login">{{$lang.messages.login}}</router-link>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

